<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <form>
          <vue-form-generator :schema="schema" :model="model" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'

export default {
  name: 'ObjectGroupCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component
  },
  data () {
    return {
      model: {
        name: '',
        schema: '',
        model: '',
        submit: {}
      },
      schema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            label: 'Name',
            model: 'name',
            required: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Schema',
            model: 'schema',
            require: true
          },
          {
            type: 'input',
            inputType: 'text',
            label: 'Model',
            model: 'model',
            required: true
          },
          {
            type: 'submit',
            buttonText: 'Save',
            onSubmit: this.onSave
          }
        ]
      }
    }
  },
  props: {
    objectGroupId: 0
  },
  methods: {
    onSave () {
      var url = '/api/objectdescriptions'
      this.$http
        .post(url, {
          objectdescription: {
            objectGroupId: this.$props.objectGroupId, ...this._.omit(this.model, 'submit')
          }
        })
        .then(response => {
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ObjectManagement/ObjectDescriptionCreate.vue